function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Union 131",
  d: "M20.817 21.634a1 1 0 0 1-1-1V9.049a1 1 0 0 1 1-1h1.705a1 1 0 0 1 1 1v11.585a1 1 0 0 1-1 1zm-6.175 0a1 1 0 0 1-1-1v-7.469a1 1 0 0 1 1-1h1.706a1 1 0 0 1 1 1v7.469a1 1 0 0 1-1 1zm-6.587 0a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1H9.76a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1zm-6.586 0a1 1 0 0 1-1-1v-2.94a1 1 0 0 1 1-1h1.705a1 1 0 0 1 1 1v2.94a1 1 0 0 1-1 1zM.444 13.4a.413.413 0 0 1-.061-.823c.086 0 7.793-1.647 12.193-4.862a56.175 56.175 0 0 0 6.789-5.735L18.311.927a.412.412 0 0 1 .272-.7L23.568 0A.41.41 0 0 1 24 .428l-.235 5.007a.412.412 0 0 1-.7.271L21.79 4.434a26.066 26.066 0 0 1-8.374 6.451A28.2 28.2 0 0 1 1.71 13.438c-.439 0-.863-.012-1.266-.038z",
  transform: "translate(-.001)"
}));

function SvgUpChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 21.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpChart);
export default __webpack_public_path__ + "static/media/up_chart.e3323532.svg";
export { ForwardRef as ReactComponent };